module.exports = __webpack_public_path__ + "img/staff-owen-banks.ce7dceb1.jpg";